import { spacing, font, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-code";
const code = objectWithClassName({
  className: [
    `${classNamePrefix}`,
    /** @deprecated Use 'umd-text-code' instead */
    `umd-rich-text-coding`
  ],
  "& code, & pre": {
    border: `1px solid ${color.gray.lightest}`,
    backgroundColor: color.gray.lightest,
    borderRadius: "3px",
    color: "currentColor",
    FontFamily: font.family.mono
  },
  "& code": {
    display: "inline-block",
    padding: `0 ${spacing.min}`
  },
  "& pre": {
    padding: spacing.min
  }
});
export {
  code
};
//# sourceMappingURL=code.js.map
